__turbopack_context__.v({
  "section-bg-text": "Y1hNiq_section-bg-text",
  "section-bg-text--loaded": "Y1hNiq_section-bg-text--loaded",
  "section-bg-text__inner": "Y1hNiq_section-bg-text__inner",
});
